import { useLocale } from "next-intl";
import { FC } from "react";

import Image from "@/components/ui/Image/Image";
import { TileCarouselCardProps } from "@/types";

import RichText from "../RichText/RichText";

const TileCarouselCardContent: FC<{ item: TileCarouselCardProps; openModal: () => void }> = ({ item, openModal }) => {
  return (
    <div className="w-full md:w-fit relative mb-m md:mb-0">
      {item.image && (
        <div className="relative">
          <Image
            src={item.image.url}
            width={255}
            height={453}
            className="aspect-2-1 w-full md:w-[255px] h-[453px] rounded-lg shadow-elevation"
            alt={item.image.title || ""}
          />
          {item.logo && <div className={`absolute w-full h-full top-0 left-0 inset-0 ${item.logo ? "img-overlay-5" : "img-overlay-3"}`}></div>}
        </div>
      )}
      {item.logo && (
        <div className="absolute bottom-0 top-0 text-white pt-xs flex justify-center w-1/2 mx-auto left-0 right-0">
          <Image src={item.logo.url} width={item.logo.width || 128} height={item.logo.height || 72} className="h-fit" alt={item.logo.title || ""} />
        </div>
      )}
      <div
        className="absolute bottom-0 z-10 text-white px-s pb-m w-full text-center md:rtl:text-right tile-carousel-content"
        style={{ color: item.titleColor ? item.titleColor : undefined }}
      >
        {item?.overtitle && <div className="font-primary font-normal text-xs pb-xs">{item.overtitle}</div>}
        <div className="font-primary text-m font-medium leading-5 pb-xxs tile-carousel-title">{item.title}</div>
        {item.abstract && <div className="font-primary text-s leading-4 tile-carousel-description">{item.abstract}</div>}
        {item?.abstractRtf && !item?.abstract && (
          <div className="font-primary text-s leading-4 tile-carousel-description">
            <RichText content={item.abstractRtf} />
          </div>
        )}
      </div>
    </div>
  );
};
export default TileCarouselCardContent;
